import { render, staticRenderFns } from "./DispensaEditar.vue?vue&type=template&id=2e792fd6&scoped=true&"
import script from "./DispensaEditar.vue?vue&type=script&lang=js&"
export * from "./DispensaEditar.vue?vue&type=script&lang=js&"
import style0 from "./DispensaEditar.vue?vue&type=style&index=0&id=2e792fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e792fd6",
  null
  
)

export default component.exports